module.exports = __webpack_public_path__ + "img/dots_rtb3.06ae5623.png";